module.exports = __webpack_public_path__ + "img/individual.038ae3e4.svg";